import { useNavigate } from "react-router-dom";
import {
  AnalyticsSmallSvg,
  AppConnectSvg,
  CardManageSvg,
  EditInfoSvg,
  OtherSmallSvg,
  PremiumMoreSvg,
  ReviewSmallSvg,
  arrowRightSvg,
} from "../../components/Assets";
import { ROUTE_PATHS } from "../../constants/Router";
import useAuth from "../../hooks/useAuth";
import { useFetchHome } from "../../hooks/useFetchHomePage";
import LocalUtils from "../../utils/localUtils";
import { useSelector } from "react-redux";

const MenuItem = ({ label, navigateTo, handleClick, renderRight }) => {
  const navigate = useNavigate();
  const handleClickItem = () => {
    if (handleClick) {
      handleClick();
    } else {
      navigate(navigateTo);
    }
  };

  return (
    <div
      className="flex justify-between items-center py-2.5"
      onClick={handleClickItem}
    >
      <div className="text-[15px]">{label}</div>
      <div>{renderRight()}</div>
    </div>
  );
};

const More = function () {
  const { logout, ceoInfo } = useAuth();

  const mCeo = useSelector((state) => state.Ceo);
  const ceoType = mCeo?.ceoType;

  const { shopInfo } = useFetchHome();

  const navigate = useNavigate();
  const replaceUrl = (replacement) => {
    return ROUTE_PATHS.Review.replace("*", replacement);
  };
  const icons = [
    {
      icon: <img src={EditInfoSvg} alt="Edit info" />,
      label: "정보 수정",
      premiumNavigateTo: ROUTE_PATHS.EditInfo,
      normalNavigateTo: ROUTE_PATHS.EditInfo,
    },
    {
      icon: <img src={AppConnectSvg} alt="App connect" />,
      label: "배달 앱 연동",
      premiumNavigateTo: ROUTE_PATHS.AppConnect,
      normalNavigateTo: ROUTE_PATHS.AppConnect,
    },
    {
      icon: <img src={CardManageSvg} alt="Card manage" />,
      label: "납부 관리",
      premiumNavigateTo: ROUTE_PATHS.CardManage,
      normalNavigateTo: ROUTE_PATHS.HistoryPayment,
    },
    {
      icon: <img src={PremiumMoreSvg} alt="Premium" />,
      label: "프리미엄",
      premiumNavigateTo: ROUTE_PATHS.PremiumServiceManagement,
      normalNavigateTo: ROUTE_PATHS.PremiumServiceManagement,
    },
  ];
  const section = [
    {
      title: "리뷰",
      icon: ReviewSmallSvg,
      childrends: [
        {
          title: "일반 리뷰",
          navigateTo: replaceUrl(""),
          type: "link",
        },
        {
          title: "관심 리뷰",
          navigateTo: replaceUrl("special"),
          type: "link",
        },
        {
          title: "댓글 설정",
          navigateTo: replaceUrl("setting"),
          type: "link",
        },
      ],
    },
    {
      title: "분석",
      icon: AnalyticsSmallSvg,
      childrends: [
        {
          title: "월간 리포트",
          navigateTo: ROUTE_PATHS.Analytics,
          type: "link",
        },
      ],
    },
    {
      title: "기타",
      icon: OtherSmallSvg,
      childrends: [
        {
          title: "약관 및 개인정보 처리 동의",
          navigateTo: ROUTE_PATHS.TermAndPolicy,
          type: "link",
        },
        {
          title: "현재 버전",
          navigateTo: false,
          labelRight: "v1.0.1",
          type: "label",
        },
        {
          title: "로그아웃",
          navigateTo: false,
          handleClick: () => {
            logout();
          },
        },
      ],
    },
  ];

  return (
    <div>
      <div className="px-5 pt-6 pb-4">
        <b className="text-22">{shopInfo?.shop_name}</b>
      </div>
      <div className="px-2 pt-6 pb-7 flex items-center justify-center bg-[#F5F7FF]">
        {icons.map((item, index) => {
          return (
            <div
              key={index}
              className="flex-col items-center justify-center w-[86px] h-[73px]"
              onClick={() =>
                navigate(
                  ceoType === "PREMIUM"
                    ? item.premiumNavigateTo
                    : item.normalNavigateTo
                )
              }
            >
              <div className="flex justify-center">{item.icon}</div>
              <div className="text-center">{item.label}</div>
            </div>
          );
        })}
      </div>
      <div className="pb-32 px-5">
        {section.map((item, index) => {
          return (
            <div className="pt-12" key={index}>
              <div className="flex items-center mb-4">
                <img className="mr-3" src={item.icon} />
                <b>{item.title}</b>
              </div>
              {item.childrends.map((child, childIndex) => {
                return (
                  <MenuItem
                    key={childIndex}
                    label={child.title}
                    navigateTo={child.navigateTo}
                    handleClick={child.handleClick}
                    renderRight={() => {
                      switch (child.type) {
                        case "label":
                          return (
                            <span className="text-[#A0A5B5] text-[15px]">
                              {child.labelRight}
                            </span>
                          );
                        case "link":
                          return <img src={arrowRightSvg} alt="arrow" />;
                        default:
                          return null;
                      }
                    }}
                  />
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default More;
